import { Link, Stack, Typography } from "@mui/material"
import { Link as RouterLink } from "react-router-dom"
import { Userbot } from "../../interfaces"
import { formatOrigin } from "./stepFailure"

export const ReportProvenance = ({
  report,
}: {
  report: Userbot.ReportProvenance
}) => (
  <Stack spacing={0.5} mb={2}>
    <Typography variant="body2">
      Источник: {formatOrigin(report.origin)}
    </Typography>
    {report.scheduleId ? (
      <Link
        component={RouterLink}
        to={`/userbot/scheduled/${report.scheduleId}/runs`}
      >
        Расписание: {report.scheduleId}
      </Link>
    ) : (
      <Typography variant="body2">Расписание: —</Typography>
    )}
    {report.runId && report.scheduleId ? (
      <Link
        component={RouterLink}
        to={`/userbot/scheduled/${report.scheduleId}/runs#run-${report.runId}`}
      >
        Запуск: {report.runId}
      </Link>
    ) : (
      <Typography variant="body2">Запуск: {report.runId ?? "—"}</Typography>
    )}
    {report.groupId ? (
      <Link component={RouterLink} to={`/userbot/batches/${report.groupId}`}>
        Группа: {report.groupId}
      </Link>
    ) : (
      <Typography variant="body2">Группа: —</Typography>
    )}
    <Typography variant="body2">Элемент: {report.itemId ?? "—"}</Typography>
  </Stack>
)
